import { Box } from "@chakra-ui/react";
import {
  Dict,
  getAccountFilterFromQuery,
  getOpportunityFilterQuery,
  VeriTabPanel,
  VeriTabs,
} from "@verivest/shared-components";
import { useFlattenedInvestmentModel } from "@verivest/shared-components/src/api/hooks/models/useFlattenedInvestmentModel";
import { VeriAsyncRouteComponentType } from "@verivest/shared-components/src/defines/after-js-types";
import useGetDataOrDefaults from "@verivest/shared-components/src/hooks/data/useGetDataOrDefaults";
import React from "react";
import { Card } from "../../../components";
import { InvestorPortalWhiteLabelPageContainer } from "../../../components/investor-portal/layouts/InvestorPortalWhiteLabelPageContainer";
import { TransactionsEmptyStatusView } from "../../../components/investor-portal/white-label/transactions/TransactionsEmptyStatusView";
import { TransactionsTable } from "../../../components/investor-portal/white-label/transactions/TransactionsTable";
import { ManagerWhiteLabelRouteParams } from "../../../routes/investorPortalPages.types";
import {
  ManagerWhiteLabelRoutesServerInitialProps,
  WhiteLabelPageExtraProps,
} from "./types";

export const TransactionsPage: VeriAsyncRouteComponentType<
  ManagerWhiteLabelRoutesServerInitialProps & WhiteLabelPageExtraProps,
  ManagerWhiteLabelRouteParams
> = (props) => {
  const flattenedInvestmentModel = useFlattenedInvestmentModel();

  const { data: groupedInvestments } = useGetDataOrDefaults(
    undefined,
    async () => {
      return (
        await flattenedInvestmentModel.getMany(undefined, {
          manager_id: String(props.manager?.id),
        })
      )?.meta as Dict;
    },
  );

  if (!props.manager || groupedInvestments === undefined) return <></>;

  if (groupedInvestments && !groupedInvestments["rows-total"]) {
    return <TransactionsEmptyStatusView managerIdOrSlug={props.manager?.id} />;
  }

  const urlParams = new URLSearchParams(props.location.search);
  const selectedFilterOpportunity = getOpportunityFilterQuery(urlParams);
  const selectedFilterAccount = getAccountFilterFromQuery(urlParams);

  return (
    <InvestorPortalWhiteLabelPageContainer
      px={0}
      py={10}
      title={"Transactions"}
    >
      <Box>
        <VeriTabs
          tabListWrapperProps={{ p: 0, maxW: "260px", w: "100%" }}
          tabListWrapperAs={Card}
          isVertical
        >
          <VeriTabPanel label={"All transactions"}>
            <TransactionsTable
              selectedFilterOpportunity={selectedFilterOpportunity}
              selectedFilterAccount={selectedFilterAccount}
              category={""}
              manager={props.manager}
            />
          </VeriTabPanel>
          <VeriTabPanel label={"Contributions"}>
            <TransactionsTable
              category={"contributions"}
              manager={props.manager}
            />
          </VeriTabPanel>
          <VeriTabPanel label={"Distributions"}>
            <TransactionsTable
              selectedFilterOpportunity={selectedFilterOpportunity}
              selectedFilterAccount={selectedFilterAccount}
              category={"distributions"}
              manager={props.manager}
            />
          </VeriTabPanel>
          <VeriTabPanel label={"Redemptions"}>
            <TransactionsTable
              selectedFilterOpportunity={selectedFilterOpportunity}
              selectedFilterAccount={selectedFilterAccount}
              category={"redemptions"}
              manager={props.manager}
            />
          </VeriTabPanel>
          <VeriTabPanel label={"Net Income"}>
            <TransactionsTable
              selectedFilterOpportunity={selectedFilterOpportunity}
              selectedFilterAccount={selectedFilterAccount}
              category={"net_income"}
              manager={props.manager}
            />
          </VeriTabPanel>
        </VeriTabs>
      </Box>
    </InvestorPortalWhiteLabelPageContainer>
  );
};

TransactionsPage.getInitialProps = async () => {
  const result: ManagerWhiteLabelRoutesServerInitialProps = {};
  return result;
};

TransactionsPage.getChunkName = () =>
  "investor-portal-3-manager-white-label-transactions-page";
